import './public-path';
import './styles/index.scss';

import { raygunInit } from 'app/helpers/raygun';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import { registerRequestInterceptor } from './app/api/interceptors/registerRequestInterceptor';
import { registerResponseInterceptor } from './app/api/interceptors/registerResponseInterceptor';
import App from './app/App';
import { setCustomConsoleLog } from './app/helpers/customConsoleLog';
import * as serviceWorker from './serviceWorker';

// http interceptors
registerRequestInterceptor();
registerResponseInterceptor();

raygunInit();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

setCustomConsoleLog('Accela Marketplace', '', 'success');
